export default __webpack_public_path__ + "static/media/green_check.d8332768.svg";